import React from 'react';

import ValutaFilter from '@eika-infrastruktur/ui-valuta-filter';
import { Label } from '@eika/label';

import { StringKeyValue } from '../../actions/types';

interface Props {
    text: StringKeyValue;
    className: string;
    equity: number | undefined;
    price: number | undefined;
}

const EquityInfo = ({ className, equity, price, text }: Props): JSX.Element => {
    const {
        calculatorEquityInfoHelperText1,
        calculatorEquityInfoHelperText2A,
        calculatorEquityInfoHelperText2B,
        calculatorEquityInfoHelperText2C,
        calculatorEquityInfoHelperText3,
    } = text;

    if (typeof equity !== 'undefined' && typeof price !== 'undefined') {
        const priceNumber = Number(price);
        const equityNumber = Number(equity);

        const amountToNextInterestRate = (limit: number, priceNumber: number) =>
            Math.ceil(priceNumber - priceNumber * limit);

        const equityLimitPercentageMid = 20.0;
        const equityLimitPercentageHigh = 35.0;
        const equityPercentage = (equityNumber * 100.0) / priceNumber;
        // @ts-ignore
        const printableEquityPercentage = Math.floor(parseFloat(equityPercentage)).toFixed(0);

        let helpText = `${calculatorEquityInfoHelperText1} ${printableEquityPercentage}%. `;
        if (equityPercentage < equityLimitPercentageMid) {
            const formattedEquityLimitAmountMid = `${ValutaFilter(amountToNextInterestRate(0.8, priceNumber), ' ', 0)}`;
            helpText = `${helpText}${calculatorEquityInfoHelperText2A} ${formattedEquityLimitAmountMid},- ${calculatorEquityInfoHelperText2B} 20% ${calculatorEquityInfoHelperText2C}`;
        } else if (equityPercentage >= equityLimitPercentageMid && equityPercentage < equityLimitPercentageHigh) {
            const formattedEquityLimitAmountHigh = `${ValutaFilter(
                amountToNextInterestRate(0.65, priceNumber),
                ' ',
                0,
            )}`;
            helpText = `${helpText}${calculatorEquityInfoHelperText2A} ${formattedEquityLimitAmountHigh},- ${calculatorEquityInfoHelperText2B} 35% ${calculatorEquityInfoHelperText2C}`;
        } else {
            helpText = `${helpText}${calculatorEquityInfoHelperText3}`;
        }

        return (
            <div>
                <Label className={className} text={helpText} />
            </div>
        );
    }
    return <div />;
};

export default EquityInfo;
